var _path, _path2, _path3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNetbanking(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 0C18.2091 0 20 1.79086 20 4V16C20 18.2091 18.2091 20 16 20H4C1.79086 20 3.22133e-08 18.2091 0 16V7H5.33301C5.7012 7 6 6.77614 6 6.5C6 6.22386 5.7012 6 5.33301 6H0V5H3.5C3.77614 5 4 4.77614 4 4.5C4 4.22386 3.77614 4 3.5 4H0C0 1.79086 1.79086 3.22128e-08 4 0H16Z",
    fill: "url(#paint0_linear_2293_2)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.86914 9.46387H6.76367C5.69679 9.4639 5.50979 9.63411 5.50977 10.6055V12.5645C5.50977 13.5359 5.69673 13.706 6.76367 13.7061H10.54C11.6071 13.706 11.7939 13.536 11.7939 12.5645V12.043H12.3037V12.5645C12.3071 13.7991 11.8957 14.1738 10.543 14.1738H8.95605V15.3906H10.2178C10.3602 15.3909 10.4785 15.5291 10.4785 15.6953C10.4785 15.8615 10.3602 15.9997 10.2178 16H7.08691C6.94435 15.9999 6.82617 15.8616 6.82617 15.6953C6.82621 15.529 6.94437 15.3907 7.08691 15.3906H8.34766V14.1738H6.76367C5.41118 14.1738 5 13.7988 5 12.5674V10.6055C5.00005 9.37417 5.41126 9.00006 6.76367 9H9.86914V9.46387Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0293 11H15.9707M13 8.10936V11M14.9804 8.10936V11M11.0196 8.10936V11M13.1476 6.03324L15.8353 7.31501C16.1157 7.44872 16.0159 7.85178 15.7025 7.85178H10.2975C9.98404 7.85178 9.88428 7.44872 10.1647 7.31501L12.8524 6.03324C12.9453 5.98892 13.0547 5.98892 13.1476 6.03324Z",
    stroke: "white",
    strokeWidth: 0.504112,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2293_2",
    x1: 10,
    y1: 20,
    x2: 10,
    y2: 0,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3C40A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#474DE6"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNetbanking);
export default __webpack_public_path__ + "static/media/NETBANKING.849f8f932a8054923fa4538adcbe57af.svg";
export { ForwardRef as ReactComponent };